module.exports = __webpack_public_path__ + "static/media/scoli-adams-1f.e9349507.png";